import { useLocation } from 'react-router';

export default function useShowNavigation() {
    const { search } = useLocation();
    return !(search && search.indexOf('hideNavigation=true') > -1);
}
